import ImageGrid from '../ImageGrid/ImageGrid';
import './EventImageView.css';

function EventImageView({ event }) {
  if (!event.images?.length) {
    return (
      <section className="event-gallery-empty" aria-label={`${event.title} gallery`}>
        <p>No photos for this activity yet.</p>
      </section>
    );
  }

  return (
    <ImageGrid
      images={event.images}
      ariaLabel={`${event.title} gallery`}
    />
  );
}

export default EventImageView;
